import { render, staticRenderFns } from "./RecentViewPage.vue?vue&type=template&id=7e3eef86&scoped=true"
import script from "./RecentViewPage.vue?vue&type=script&lang=js"
export * from "./RecentViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3eef86",
  null
  
)

export default component.exports